import {
  useGridApiContext,
  useGridSelector,
  gridPaginationModelSelector,
  gridPaginationRowCountSelector,
} from "@mui/x-data-grid";
import TablePagination from "./TablePagination";
export default function GridPagination({ pageSizeOptions }) {
  const apiRef = useGridApiContext();
  const { page, pageSize } = useGridSelector(
    apiRef,
    gridPaginationModelSelector
  );
  const count = useGridSelector(apiRef, gridPaginationRowCountSelector);
  return (
    <TablePagination
      count={count}
      page={page}
      pageSize={pageSize}
      pageSizeOptions={pageSizeOptions}
      onPageChange={(next) => apiRef.current.setPage(next)}
      onPageSizeChange={(size) =>
        apiRef.current.setPaginationModel({ page: 0, pageSize: size })
      }
    />
  );
}
